define.alias("shared/modifiers/wheel-pan", "media/modifiers/wheel-pan");